module.exports = __webpack_public_path__ + "files/57149beb846f2a9049f692e649042d8e.png";